/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ShiftAssignmentDto } from '../models/ShiftAssignmentDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShiftAssignmentControllerService {
    /**
     * @param uuid
     * @returns ShiftAssignmentDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<ShiftAssignmentDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/shift-assignments/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns ShiftAssignmentDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: ShiftAssignmentDto,
    ): CancelablePromise<ShiftAssignmentDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/shift-assignments/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/shift-assignments/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param resourceUuid
     * @param requestBody
     * @returns ShiftAssignmentDto OK
     * @throws ApiError
     */
    public static replaceAssignmentsForResource(
        resourceUuid: string,
        requestBody: Array<ShiftAssignmentDto>,
    ): CancelablePromise<Array<ShiftAssignmentDto>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/shift-assignments/resource/{resourceUuid}',
            path: {
                'resourceUuid': resourceUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ShiftAssignmentDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<ShiftAssignmentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/shift-assignments',
        });
    }
    /**
     * @param requestBody
     * @returns ShiftAssignmentDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: ShiftAssignmentDto,
    ): CancelablePromise<ShiftAssignmentDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/shift-assignments',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
